var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13668",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4965 6.54639C11.9488 6.54639 11.5048 6.9904 11.5048 7.53812V11.007H8.03666C7.48894 11.007 7.04492 11.451 7.04492 11.9987C7.04492 12.5464 7.48894 12.9904 8.03666 12.9904H11.5048V16.4637C11.5048 17.0115 11.9488 17.4555 12.4965 17.4555C13.0443 17.4555 13.4883 17.0115 13.4883 16.4637V12.9904H16.9623C17.51 12.9904 17.954 12.5464 17.954 11.9987C17.954 11.451 17.51 11.007 16.9623 11.007H13.4883V7.53812C13.4883 6.9904 13.0443 6.54639 12.4965 6.54639Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.fe6b1edbc32ce8f28c67f89211683030.svg";
export { ForwardRef as ReactComponent };